import { render, staticRenderFns } from "./view-mode-switch.component.vue?vue&type=template&id=817b3944"
import script from "./view-mode-switch.component.vue?vue&type=script&lang=js"
export * from "./view-mode-switch.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports